/**
 * Created by rouven on 10.05.17.
 */
import { userReducer as baseReducer, actionTypes } from '@wikom/wikom-data';
var userReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    return (action.type === actionTypes.LOAD_DATA_SUCCESS && action.name === 'user'
        ? Object.assign({}, state, action.data)
        : baseReducer(state, action));
};
export default userReducer;
